<template>
    <div class="vehicle__overview">
        <div>
            <p v-if="vehicle.owner.isOrganizationRepresentative">{{ $t('pages.vehicle.rented_out_by_a_company') }}</p>
            <ul class="overview-list">
                <template v-for="field in filteredFields">
                    <DrivingLicenseOverviewListItem v-if="field === 'drivingLicense'" :key="field" :vehicle="vehicle" />
                    <OverviewListItem v-else :key="field" :vehicle="vehicle" :field="field" />
                </template>
            </ul>
            <button
                v-if="isShowAllCharacteristicsVisible"
                class="vehicle-section__button button button--secondary-contrast button--small"
                @click="$emit('click')"
            >
                {{ $t('pages.vehicle.show_all_characteristics') }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OverviewListItem from '~/components/vehicle/OverviewListItem.vue';
import DrivingLicenseOverviewListItem from '~/components/vehicle/DrivingLicenseOverviewListItem.vue';
import { hiddenFieldsByVehicleType } from '~/config/vehicleFields';

export default {
    components: {
        OverviewListItem,
        DrivingLicenseOverviewListItem,
    },
    props: {
        vehicle: {
            type: Object,
            default: () => {},
        },
        displayAll: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fields: [
                'brand',
                'model',
                'modelYear',
                'transmission',
                'fueltype',
                'euro6Compliant',
                'winterized',
                'winterTyreType',
                'childSafetySeat',
                'allWheelDrive',
                'width',
                'length',
                'height',
                'curbWeight',
                'maximumAuthorizedMass',
                'drivingLicense',
            ],
        };
    },
    computed: {
        ...mapGetters(['isLargeScreen']),
        sliceTo() {
            return this.isLargeScreen ? 8 : 4;
        },
        filteredFields() {
            if (!this.isShowAllCharacteristicsVisible) {
                return this.includedVehicleCharacteristics;
            }

            return this.includedVehicleCharacteristics.slice(0, this.sliceTo);
        },
        includedVehicleCharacteristics() {
            return this.fields.filter(field => {
                return (
                    this.vehicle[field] !== undefined &&
                    this.vehicle[field] !== null &&
                    !hiddenFieldsByVehicleType[this.vehicle.subType].includes(field)
                );
            });
        },
        isShowAllCharacteristicsVisible() {
            return this.includedVehicleCharacteristics.length > this.sliceTo && !this.displayAll;
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.vehicle__overview {
    .overview-list {
        @include lg {
            columns: 2;
            column-gap: 20px;

            &--loading {
                columns: 1;
            }
        }

        a {
            text-decoration: none;
            color: $primary-text-color;
            width: fit-content;

            &:hover,
            &:active {
                text-decoration: underline;
            }
        }
    }
}
</style>
